/**
 * @flow
 * @relayHash c14869ee5060617e3714c8f67c616df5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiMessageRole = "ASSISTANT" | "SYSTEM" | "USER";
export type SendAiMessageInput = {|
  message: string,
  conversationId?: ?string,
|};
export type SendAiMessageMutationVariables = {|
  input: SendAiMessageInput
|};
export type SendAiMessageMutationResponse = {|
  +sendAiMessage: {|
    +aiMessage: {|
      +messageId: string,
      +conversationId: string,
      +role: AiMessageRole,
      +content: ?string,
      +tokensUsed: ?number,
      +createdAt: ?any,
    |},
    +conversationId: string,
  |}
|};
export type SendAiMessageMutation = {|
  variables: SendAiMessageMutationVariables,
  response: SendAiMessageMutationResponse,
|};
*/


/*
mutation SendAiMessageMutation(
  $input: SendAiMessageInput!
) {
  sendAiMessage(input: $input) {
    aiMessage {
      messageId
      conversationId
      role
      content
      tokensUsed
      createdAt
    }
    conversationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendAiMessageInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "conversationId",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendAiMessage",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendAiMessagePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "aiMessage",
        "storageKey": null,
        "args": null,
        "concreteType": "AiMessage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messageId",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "role",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "content",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tokensUsed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      },
      (v1/*: any*/)
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendAiMessageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SendAiMessageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendAiMessageMutation",
    "id": null,
    "text": "mutation SendAiMessageMutation(\n  $input: SendAiMessageInput!\n) {\n  sendAiMessage(input: $input) {\n    aiMessage {\n      messageId\n      conversationId\n      role\n      content\n      tokensUsed\n      createdAt\n    }\n    conversationId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2bbcf949f3f6f1f81c5b5e02a499f08f';
module.exports = node;
